import type { RefObject } from 'react';
import { createRef } from 'react';

type DynamicRef = RefObject<string> | unknown;

const refs: Record<string, DynamicRef> = {};

function useDynamicRefs() {
  function addRef(name: string, thirdPartyRef?: DynamicRef) {
    const ref = thirdPartyRef ? thirdPartyRef : createRef<string>();
    refs[name] = ref;
    return ref;
  }

  function getRef(name: string) {
    return refs[name];
  }

  return { addRef, getRef, refs };
}

export default useDynamicRefs;